var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('router-view'),_c('tag-pager'),_c('feedback-global',{attrs:{"is-setup":""}}),_c('error-warnings'),_c('success-alert'),_c('modal-loaders'),_c('uploads-management')],1)}
var staticRenderFns = []

export { render, staticRenderFns }